import * as Actions from './member-residence.action';
export const MemberResidenceActions = Actions;
